"use client";

import * as React from "react";
import { Check, PhoneCall } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { buttonVariants } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { cn } from "@/lib/utils";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
const requiredDocuments = ["專業聽力師預約到府檢測服務", "各式品牌助聽器現場試聽體驗", "個人化聽力復健與適應建議", "協助申請政府助聽器相關補助", "專業醫療級精密儀器到府量測", "零距離的居家貼心售後服務"];
export default function SubsidyApplicationGuide() {
  return <section data-section-id="166854" id="到府服務團隊預約" className="w-full bg-background text-foreground py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-center">
          
          {}
          <div className="md:col-span-5 order-2 md:order-1">
            <Card className="shadow-md border-border rounded-sm bg-card">
              <CardHeader>
                <CardTitle className="text-2xl md:text-3xl font-bold text-foreground tracking-tight">
                  專業聽力照護，服務到家
                </CardTitle>
                <CardDescription className="text-base mt-2 text-muted-foreground leading-relaxed">
                  瑞聲助聽器到府服務團隊，為您提供最專業、貼心的居家聽力檢測與諮詢服務，讓您足不出戶也能重拾清晰聽力。
                </CardDescription>
              </CardHeader>
              <CardContent className="space-y-6">
                <ul className="space-y-4">
                  {requiredDocuments.map((doc, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                      <div className="mt-0.5 bg-primary/10 p-1 rounded-full shrink-0">
                        <Check className="size-4 text-primary" />
                      </div>
                      <span className="text-foreground font-medium">{doc}</span>
                    </li>)}
                </ul>
                
                <div className="pt-4 border-t border-border">
                  <p className="text-sm text-muted-foreground mb-4">
                    歡迎透過 Line 預約或撥打免費專線，我們將由專人為您安排服務。
                  </p>
                  <Link to="tel:0800555705" className={cn(buttonVariants({
                  size: "lg"
                }), "w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90 rounded-sm font-bold shadow-sm transition-colors")}>
                    <PhoneCall className="mr-2 size-4" />
                    立即撥打免費專線：0800555705
                  </Link>
                </div>
              </CardContent>
            </Card>
          </div>

          {}
          <div className="md:col-span-7 order-1 md:order-2">
            <div className="rounded-sm overflow-hidden shadow-md border border-border bg-card">
              <AspectRatio ratio={16 / 10}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1598117/img/subsidy_application_process_infographic.png" alt="瑞聲助聽器專業到府服務團隊" className="w-full h-full object-cover" />
              </AspectRatio>
            </div>
          </div>

        </div>
      </div>
    </section>;
}